<template>
  <div class="modal-content">
    <div class="modal-header justify-content-between align-items-center bg-light px-2 py-1">
      <div class="flex-grow-1 w-0 text-truncate">
        <ul class="list-inline mb-0 d-flex align-items-center text-truncate">
          <li class="list-inline-item mx-0 pr-0 pr-md-2 border-right">
            <button type="button" class="btn btn-light text-secondary d-flex" @click="onClose">
              <i class="pz-icon icon-cancel mr-1"></i>
              <span class="d-none d-md-inline-block">关闭</span>
            </button>
          </li>
          <li class="list-inline-item ml-2 ml-md-3 text-truncate">
            <h5 class="modal-title text-truncate f-xs-14">{{ title }}</h5>
          </li>
        </ul>
      </div>
      <!-- <h5 class="modal-title text-center">{{ title }}</h5> -->

      <ul class="list-inline mb-0">
        <li class="list-inline-item mx-0 mx-lg-2">
          <button
            type="button"
            class="btn btn-light text-secondary d-flex flex-column"
            @click="onResizeModal"
          >
            <i
              class="pz-icon"
              :class="`${isFullscreen ? 'icon-fullscreen-exit' : 'icon-fullscreen'}`"
            ></i>
            <small class="d-none d-md-inline-block">全屏</small>
          </button>
        </li>
      </ul>
    </div>

    <div class="modal-body p-0" v-if="list.length">
      <!-- 收藏 -->
      <div class="list-group list-group-flush" v-if="exerciseType === 2">
        <a
          href="javascript:undefined"
          @click.prevent="doFilter({ bookId: -1 })"
          class="list-group-item list-group-item-action d-flex py-5 bg-warning text-white px-3"
        >
          <h5 class="mb-0">累计收藏</h5>
          <h5 class="mb-0 ml-auto">{{ sum }}</h5>
          <i class="pz-icon icon-chevron-right"></i>
        </a>
        <a
          href="javascript:undefined"
          @click.prevent="doFilter({ bookId: item.bookId })"
          :key="`collection-list-key-${idx}`"
          v-for="(item, idx) in list"
          class="list-group-item list-group-item-action d-flex px-3"
        >
          {{ item.bookName }}
          <span class="ml-auto d-flex">
            {{ item.questionCount }}
            <i class="pz-icon icon-chevron-right"></i>
          </span>
        </a>
      </div>

      <!-- 错题本 -->
      <div class="list-group list-group-flush" v-if="exerciseType === 3">
        <a
          href="javascript:undefined"
          @click.prevent="doFilter({ bookId: -1 })"
          class="list-group-item list-group-item-action d-flex py-5 bg-danger text-white px-3"
        >
          <h5 class="mb-0">累计错题</h5>
          <h5 class="mb-0 ml-auto">{{ sum }}</h5>
          <i class="pz-icon icon-chevron-right"></i>
        </a>
        <a
          href="javascript:undefined"
          @click.prevent="doFilter({ bookId: item.bookId })"
          :key="`wrong-list-key-${idx}`"
          v-for="(item, idx) in list"
          class="list-group-item list-group-item-action d-flex px-3"
        >
          {{ item.bookName }}
          <span class="ml-auto d-flex">
            {{ item.questionCount }}
            <i class="pz-icon icon-chevron-right"></i>
          </span>
        </a>
      </div>

      <!-- 章节 -->
      <div class="modal-body p-0 bg-white" style="height: 500px" v-if="exerciseType === 5">
        <form class="p-5">
          <div class="form-group">
            <label for="BookSelect1">书名</label>
            <select
              class="form-control form-control-lg"
              v-model="bookId"
              @change="changeBook(bookId)"
            >
              <option
                v-for="(item, idx) in books"
                :value="item.bookId"
                :key="`book-tree-filter-${idx}`"
              >
                {{ item.bookName }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="ReadingSelect1">章节</label>
            <select
              v-model="readingId"
              @change="changeReading(readingId)"
              class="form-control form-control-lg"
              id="ReadingSelct1"
            >
              <option
                v-for="(item, idx) in readings"
                :value="item.readingId"
                :key="`book-tree-filter-reading-${idx}`"
              >
                {{ item.readingName }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="ReadingSelect1">出题数量</label>
            <select v-model="limit" class="form-control form-control-lg">
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="30">30</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </form>
      </div>
      <!-- 专项练习 -->
      <div class="p5" v-if="exerciseType === 6">
        <dl class="row mb-5" v-for="(group, groupIdx) in Groups" :key="`group-key-${groupIdx}`">
          <dt class="col-12 mb-2">{{ group.groupName }}</dt>
          <template v-for="(type, typeIdx) in group.types">
            <dd class="col-6" :key="`group-key-${typeIdx}`" v-if="type.questionCount">
              <button
                type="button"
                @click="selectType(type)"
                class="btn btn-light btn-block d-flex justify-content-between btn-filter-active"
                :class="{ active: type.isSelected }"
              >
                {{ type.typeName }}
                <span class="ml-auto">{{ type.questionCount }}</span>
                <i class="pz-icon icon-check text-success ml-3"></i>
              </button>
            </dd>
          </template>
        </dl>
      </div>
    </div>

    <div
      class="modal-footer bg-light justify-content-between"
      v-if="exerciseType === 5 || exerciseType === 6"
    >
      <ul class="modal-footer-right list-inline">
        <li class="list-inline-item">
          <span class="text-muted" v-if="exerciseType === 5">共{{ sumType5 }}道题</span>
        </li>
      </ul>
      <ul class="modal-footer-right list-inline">
        <li class="list-inline-item">
          <button
            @click="doFilter"
            :disabled="exerciseType === 6 && selectedTypeArr.length == 0"
            type="button"
            class="btn btn-primary px-4"
          >
            开始练习
          </button>
        </li>
      </ul>
    </div>

    <div class="modal-footer bg-light justify-content-between" v-if="exerciseType === 3">
      <ul class="modal-footer-right list-inline">
        <li class="list-inline-item">
          <!-- <span class="text-muted" v-if="exerciseType === 5">共{{ reading.questionCount }}道题</span> -->
        </li>
      </ul>
      <ul class="modal-footer-right list-inline">
        <li class="list-inline-item">
          <div class="custom-control custom-switch">
            <input
              type="checkbox"
              id="customSwitch1"
              v-model="autoRemoveWronglist"
              class="custom-control-input"
            />
            <label for="customSwitch1" class="custom-control-label">答对后自动移除错题</label>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { findIndex, groupBy } from 'lodash';
import { mapGetters, mapActions } from 'vuex';
// import { updateProfile } from '../../global/service';

export default {
  name: 'FirstFilter',

  props: {
    isFullscreen: Boolean,
    onResizeModal: Function,
    exerciseType: {
      type: Number,
      default: () => '',
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    title: String,
    list: Array,

    onGetQuestions: {
      type: Function,
      default: () => {},
    },

    setIsShowFirstFilterPanelAndContent: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      bookIdx: 0,
      readingIdx: 0,
      limit: 10,
      selectedTypeArr: [],
    };
  },

  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),

    autoRemoveWronglist: {
      get: function () {
        return this.userInfo.profile.autoRemoveWronglist;
      },
      set: function (autoRemoveWronglist) {
        this.updateProfile({ autoRemoveWronglist });
      },
    },

    Groups: {
      get: function () {
        const obj = groupBy(this.list, 'group');
        let arr = [];
        for (let key in obj) {
          arr.push({
            groupId: key,
            groupName: obj[key][0].groupName,
            types: obj[key].map((v) => {
              return {
                ...v,
                isSelected:
                  findIndex(this.selectedTypeArr, {
                    group: v.group,
                    typeValue: v.typeValue,
                  }) !== -1
                    ? true
                    : false,
              };
            }),
          });
        }
        return arr;
      },
    },

    sum: function () {
      if (this.exerciseType === 3 || this.exerciseType === 2) {
        return this.list.reduce((accumulator, item) => accumulator + item.questionCount, 0);
      }
      return 0;
    },

    sumType5: function () {
      if (this.exerciseType === 5) {
        if (-1 === this.bookId) {
          return this.list.reduce((accumulator, item) => accumulator + item.questionCount, 0);
        } else {
          if (-1 === this.readingId) {
            return this.book.questionCount;
          } else {
            return this.reading.questionCount;
          }
        }
      }
      return 0;
    },

    books: function () {
      return [
        {
          bookId: -1,
          bookName: '全部',
          questionCount: 0, //this.list[this.bookIdx].questionCount,
          readings: [],
        },
        ...this.list,
      ];
    },

    bookId: {
      get: function () {
        return this.books[this.bookIdx].bookId;
      },
      set: function (bookId) {
        this.bookIdx = findIndex(this.books, { bookId });
      },
    },

    book: function () {
      return this.books[findIndex(this.books, { bookId: this.bookId })];
    },

    readingId: {
      get: function () {
        return this.readings[this.readingIdx].readingId;
      },
      set: function (readingId) {
        this.readingIdx = findIndex(this.readings, { readingId });
      },
    },

    readings: {
      get: function () {
        return [
          {
            readingId: -1,
            readingName: '全部',
            questionCount: this.books[this.bookIdx].questionCount,
          },
          ...this.books[this.bookIdx].readings,
        ];
      },
      set: function (bookId) {
        this.bookIdx = findIndex(this.books, { bookId });
      },
    },

    reading: function () {
      return this.readings[findIndex(this.readings, { readingId: this.readingId })];
    },
  },

  methods: {
    ...mapActions({
      updateProfile: 'updateProfile',
    }),

    async doFilter(payload) {
      this.setIsShowFirstFilterPanelAndContent(false);
      if (this.exerciseType === 3 || this.exerciseType === 2) {
        this.onGetQuestions({
          practiceType: this.exerciseType,
          bookId: payload.bookId,
          readingId: -1,
          attribute: [],
        });
      } else if (this.exerciseType === 5) {
        this.onGetQuestions({
          practiceType: 8, //this.exerciseType,
          bookId: this.bookId,
          readingId: this.readingId,
          attribute: [],
          random: true,
          limit: this.limit,
        });
      } else if (this.exerciseType === 6) {
        await this.onGetQuestions({
          practiceType: this.exerciseType,
          bookId: -1,
          readingId: -1,
          attribute: this.selectedTypeArr,
        });
      }
    },

    changeBook(bookId) {
      this.bookId = bookId;
      this.readingId = this.readings[0].readingId;
    },

    changeReading(readingId) {
      this.readingId = readingId;
    },

    selectType(type) {
      if (!type.isSelected) {
        this.selectedTypeArr.push({
          group: type.group,
          typeValue: type.typeValue,
        });
      } else {
        const idx = findIndex(this.selectedTypeArr, {
          group: type.group,
          typeValue: type.typeValue,
        });
        this.selectedTypeArr.splice(idx, 1);
      }
    },
  },
};
</script>
<style scoped lang="scss"></style>
